import { Typography } from "components/atoms/Typography";
import { Button } from "components/atoms/Button";
import { VIEW_RECOMMENDATION_WIDGET_SMALL } from "utils/constants/GoogleTagGUIDs";
import "./index.scss";

interface IProps {
  onClick: (cardType: string) => void;
  btnLabel: string;
  cardLabel: string;
  disabled?: boolean;
}

export const ViewProgressSummaryInnerCard = ({
  onClick,
  cardLabel,
  btnLabel,
  disabled
}: IProps) => {
  const handleBtnClick = () => {
    switch (btnLabel) {
      case "View Recommendations":
        onClick("ai");
        break;
      case "View Scores":
        onClick("score");
        break;
      case "View Progress Summary":
        onClick("progress");
        break;
    }
  };
  return (
    <div className="view-progress-summary-inner-card">
      <div className="inner-card-title">
        <Typography variant="h6Bold" label={cardLabel} />
      </div>
      <div className="inner-card-btn">
        <Button
          icon={false}
          type="score"
          styles="view-progress-card-inner-card-btn"
          label={btnLabel}
          onClick={handleBtnClick}
          isDisable={disabled}
          {...(btnLabel === "View Recommendations"
            ? { dataTrackingId: VIEW_RECOMMENDATION_WIDGET_SMALL }
            : {})}
        />
      </div>
    </div>
  );
};
